// extracted by mini-css-extract-plugin
export var btn = "process-module--btn--faf60";
export var col = "process-module--col--7c099";
export var desc = "process-module--desc--50146";
export var item = "process-module--item--cfd32";
export var num = "process-module--num--49a4c";
export var num1 = "process-module--num--1--332c4";
export var num2 = "process-module--num--2--8bfeb";
export var num3 = "process-module--num--3--6d6d8";
export var num4 = "process-module--num--4--f5416";
export var process = "process-module--process--ddba9";